const pages = {
  slug: 'f/pages',
  getRss: () => `${pages.slug}/rss`
}

export default pages
